// TODO: Dead Feature
//
import LateralEvent from './lateral_event';

export default class LateralEpisodicCachedEvent extends LateralEvent {
  getRecommendations(videoId) {
    var count = $("#reco_gravity").data('count') || 20;
    var targetUrl = $("#reco_gravity").data('lateral-type') || 'lateral_related_cached';

    $.ajax({
      url: `/${targetUrl}/${videoId}`,
      data: { count: count },
      success: this.recommendationCallback.bind(this)
    });
  }

  recoName() {
    return 'lateral_episodic_cached';
  }

  fallbackName() {
    return 'fallback_lateral_episodic_cached';
  }
}
